export function JobCareer() {
    return (
        <div className="container-career">
            <div className="position-title">
                <h1>Open positions</h1>
            </div>
            <div className="position-wrapper">
                <div className="position-job">
                    <div className="job-title">
                        <h2>Front End Engineer (Mid or Senior)</h2>
                    </div>
                    <ul className="job-info">
                        <li className="location"><i className="fa-solid fa-location-dot"></i>United States - <i className="fa-solid fa-wifi"></i>Ok Remote</li>
                        <li className="fulltime"><i className="fa-solid fa-building"></i>Full time</li>
                        <li className="job-desc"><i className="fa-solid fa-building"></i>Product & Engineering</li>
                    </ul>
                    <button className="apply-job">
                        apply
                    </button>
                </div>
            </div>
        </div>
    )
}